import React  from 'react';
const Loader = () => {
    return (
         <div className="container10" style={{marginTop:"50px"}}>
            <div className="box10">
                <span className="span"></span>
                <span className="span"></span>
                <span className="span"></span>
                <span className="span"></span>
            </div>
        </div>
    )  
};
  
export default Loader;